import { getDatabase, ref, set } from "firebase/database";
import { initializeApp } from "firebase/app";

/**
 * 	The firebase configuration that will be used to reference the database
 */
const firebaseConfig = {
	apiKey: "",
	authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
	databaseURL: process.env.REACT_APP_FIREBASE_URL,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_ID,
	appId: "",
};

//creates an instance of the firebase app
const firebaseApp = initializeApp(firebaseConfig);

export const writeDocReview = (
	uniqueId: string,
	docId: number,
	docName: string,
	smiley: number) => {

	const database = getDatabase(firebaseApp);
	const reference = ref(database, "docs/" + uniqueId);

	//set the needed data
	set(reference, {
		docId: docId,
		name: docName,
		score: smiley,
		date: Date.now()
		//try-catch error handling that ensures that we can keep track of the data
	}).then(() => {
		return { succeed: true };
	})
		.catch(error => {
			return { succeed: false } + error;
		});
};

export const writeDocReviewNew = (
	uniqueId: string,
	docId: number,
	docName: string,
	smiley: number,
	values: string[],
	other: string | undefined) => {

	const database = getDatabase(firebaseApp);
	const reference = ref(database, "new-docs/" + uniqueId);

	//set the needed data
	set(reference, {
		docId: docId,
		name: docName,
		score: smiley,
		values: values,
		other: other || "<undefined>",
		date: Date.now()
		//try-catch error handling that ensures that we can keep track of the data
	}).then(() => {
		return { succeed: true };
	})
		.catch(error => {
			return { succeed: false } + error;
		});
};